import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import MeetingInvite from './meeting-invite';
import RSVPButton from './rsvp-button';
import Agenda from './meeting-agenda';
import DownloadDocument from './download-document';
import {
	getCalendarInvite, removeCalendarMessage, downloadDocument, setLoadingState
} from '../actions';
import '../global';

class MeetingTile extends Component {

	constructor( props ) {
		super( props );
		this.mainCommittee = '';
		this.state = {
			show_details: [],
			on_going: false,
			calendar_invite: [],
			show_documents: [],
			show_attendance: []
		};
	}

	toggleDocumentView( meeting_id ) {

		let state = this.state;
		if ( state.show_documents.includes( meeting_id ) ) {
			const index = state.show_documents.indexOf( meeting_id );
			if ( index > -1 ) { // only splice array when item is found
				state.show_documents.splice( index, 1 );
			}
		} else {
			state.show_documents.push( meeting_id );
		}

		this.setState( state );
	}

	toggleAttendance() {
		let state = this.state;
		let meeting_id = this.props.meeting.ID;
		if ( state.show_attendance.includes( meeting_id ) ) {
			const index = state.show_attendance.indexOf( meeting_id );
			if ( index > -1 ) { // only splice array when item is found
				state.show_attendance.splice( index, 1 );
			}
		} else {
			state.show_attendance.push( meeting_id );
		}

		this.setState( state );
	}

	handleShowDetails( meeting_id ) {
		let newState = this.state;
		if ( newState.show_details.includes( meeting_id ) ) {
			const index = newState.show_details.indexOf( meeting_id );
			if ( index > -1 ) { // only splice array when item is found
				newState.show_details.splice( index, 1 );
			}
		} else {
			newState.show_details.push( meeting_id );
		}

		this.setState( newState );
	}

	getMeetingDetails() {
		const { meeting: { ID }, focus } = this.props;
		const isShown = this.state.show_details.includes( ID );
		const blackButtonClass = (focus !== 'undefined' && focus === true
		                         ) ? ' text-button-black' : '';
		if ( this.props.meeting.committees.length > 0 ) {
			return (<button
					className={ `view-details text-button${ blackButtonClass }` }
					onClick={ () => this.handleShowDetails( ID ) }
					type="button"
				>
					{ isShown ? 'Hide' : 'View' } Participating Groups
					<i
						className={ `fa-solid fa-chevron-${ isShown
						                                    ? 'up'
						                                    : 'down' }` }
						aria-hidden="true"
					/>
				</button>
			);
		} else {
			return '';
		}
	}

	getMultiCommitteeNames( ccodes ) {
		let allCommittees = this.props.meeting.post_content;
		let allCommitteesArray = allCommittees.split( ',' );
		if ( allCommitteesArray.length === 1 ) {
			return '';
		}
		return allCommitteesArray.map( ccode => {
			let committeeName = findCommittee( this.props.committees, ccode );
			return (<p>{ committeeName.title }</p>
			);
		} );
	}

	getDetailsButton() {
		let meeting = this.props.meeting;
		let meeting_id = meeting.ID;
			let meeting_documents = (typeof this.props.meetingDocuments[meeting_id] !== 'undefined') ? this.props.meetingDocuments[meeting_id] : [];
			let agenda_info = findAgenda(meeting,meeting_documents);
			let agenda = agenda_info.agenda;
			let agenda_document = agenda_info.agenda_document;
			let multi_committees = this.getMultiCommitteeNames();
			return (<Fragment>
				<Agenda meet_id={ meeting.ID } info={ meeting.dialin } type={ meeting.type } online_meeting_information={ meeting.online_meeting_information } ccode={ this.mainCommittee.code } agenda={ agenda } agenda_document={ agenda_document } />
			</Fragment>
			);
	}

	getAllCommitteesForMeeting() {
		let meeting = this.props.meeting;
		let multi_committees = this.getMultiCommitteeNames( meeting.post_content );
		if ( multi_committees.length > 0 ) {
			if ( this.state.show_details.includes( meeting.ID ) ) {
				return (<Fragment>
						<div className="multi-committees">
							{ multi_committees }
						</div>
					</Fragment>
				);
			} else {
				return '';
			}
		} else {
			return '';
		}
	}

	getRollCallAttendance() {
		let attendance = [];

		if(typeof this.props.rollCallAttendance[this.props.meeting.ID] !== 'undefined'){
			attendance = this.props.rollCallAttendance[this.props.meeting.ID];
		}
		let attendanceHTML = attendance.map( info => (<p>{ info.company_name }</p>
		) );
		let showAttendance = this.state.show_attendance.includes(this.props.meeting.ID);
		let iconClass = (showAttendance
		                )
			? 'fa-solid fa-chevron-up'
			: 'fa-solid fa-chevron-down';
		let firmsShowingClass = (showAttendance) ? ' show-attendance' : '';
		return (
			<div className="document-link">
				<div className="documents-container">
					<button onClick={ this.toggleAttendance.bind( this ) } className={"no-underline text-button material-count"} type="button" >Firms in Attendance ({ attendance.length })<i className={ iconClass } aria-hidden="true" />
					</button>
					<div className={"documents-container"+ firmsShowingClass}>
						{ this.state.show_attendance.includes( this.props.meeting.ID ) && attendanceHTML }
					</div>
				</div>
			</div>
		);
	}

	getDocuments( type ) {
		let documents = [];
		let title = '';
		let meeting_id = this.props.meeting.ID;
		switch ( type ) {
			case 'attachments':

				if ( typeof this.props.meeting.documents === 'undefined' ) {
					if ( typeof this.props.meetingDocuments[ meeting_id ] !== 'undefined' ) {
						documents = this.props.meetingDocuments[ meeting_id ].attachments;
					}
				} else {
					documents = this.props.meeting.documents.attachments;
				}
				title = 'Documents';
				break;
			case 'minutes':
				if ( typeof this.props.meeting.documents === 'undefined' ) {
					if ( typeof this.props.meetingDocuments[ meeting_id ] !== 'undefined' ) {
						documents = this.props.meetingDocuments[ meeting_id ].minutes;
					}
				} else {
					documents = this.props.meeting.documents.minutes;
				}
				title = 'Minutes';
				break;

		}

		if ( documents.length <= 0 ) {
			return (<p className="material-count disabled">{ title }(0)</p>
			);
		} else {
			//TODO need to fix IDs for this .
			let htmlDocuments = '';

			if ( this.state.show_documents.includes( meeting_id ) ) {
				htmlDocuments = documents.map( document => {
					let category = (type === 'attachments'
					               ) ? document.category : type;
					return (
						<DownloadDocument meet_id={ meeting_id } category={ category } file_name={ document.file_name }
						                  download_file_name={ document.download_file_name } id={ document.ID }
						                  bucket_name={ document.bucket_name }/>
					);
				} );
			}

			let length = documents.length;
			let title = (length === 1
			            ) ? 'Document' : 'Documents';
			title += ' (' + length + ')';
			let iconClass = (this.state.show_documents.includes(meeting_id)
			                )
				? 'fa-solid fa-chevron-up'
				: 'fa-solid fa-chevron-down';
			return (
				<div className="document-link">
					<button onClick={ this.toggleDocumentView.bind( this, meeting_id ) } className="no-underline text-button material-count" type="button" >{ title }
						<i className={ iconClass } /></button>
					<div className="documents-container">
						{ htmlDocuments }
					</div>
				</div>
			);
		}
	}

	render() {
		let meeting = this.props.meeting;
		let mainCommittee = findCommittee(this.props.committees, this.props.meeting.main_committee);
		let parentCommittee = findCommittee(this.props.committees, this.props.meeting.meeting_parent_ccode);
		this.mainCommittee = mainCommittee;
		let meetingOnGoing = (this.props.meeting.type === 'ongoing'
		                     ) ? 'ongoing-meeting' : '';
		let buttonType = 'rsvp';
		if ( meetingOnGoing ) {
			buttonType = 'roll-call';
		}
		let meetingFocus = (this.props.focus !== 'undefined' && this.props.focus === true) ? ' highlight-meeting' : '';


		return (
			<div className={ 'two-col-content-panel meeting-tile ' + meetingOnGoing + meetingFocus + (this.props.upcomingMeetingSection ? ' upcoming-meeting-section' : '') }>
				<div className={ 'col-sm-6 col-md-7 col-lg-9 committees-tab-content tab-content ' + (this.props.upcomingMeetingSection ? 'upcoming-meeting-section' : '') }>
					<div className="top-section-container">
						<span className="committee-subcategory">{ mainCommittee.policyGroup }</span>
						{ meetingOnGoing === 'ongoing-meeting' &&
						  <div className="on-going-meeting-tag">
							   <div className="live-roll-call-dot"></div>
							   Live</div>
						}
					</div>
					<h3 className="meeting-title">{ meeting.meeting_title || mainCommittee.title }</h3>
					<p className="meeting-organizer">Organized
						By: { parentCommittee.title }</p>
					{ this.getMeetingDetails() }
					{ this.getAllCommitteesForMeeting() }
					{ this.getDetailsButton() }

					{this.props.meeting.type !== 'past' && 					<RSVPButton button_type={ buttonType } ccode={ mainCommittee.code } meet_id={ meeting.ID } meeting={ meeting } /> }
				</div>
				<div className={ "right-container col-sm-3 col-md-3 col-lg-4 " + (this.props.upcomingMeetingSection ? 'upcoming-meeting-section' : '') }>
				<div className="meeting-time-container">
						<div className="meeting-datetime meeting-time-info-item">
							<i className="fa-solid fa-calendar" aria-hidden="true" />
							<span>{ meeting.nice_date.split('|')[0].trim() }</span>
						</div>
						<div className="meeting-time meeting-time-info-item">
							<i className="fa-solid fa-clock" aria-hidden="true" />
							<span>{ meeting.nice_date.split('|')[1].trim() }</span>
						</div>
						<div className="meeting-location meeting-time-info-item">
							<i className="fa-solid fa-location-dot" aria-hidden="true" />
							<span>{ meeting.nice_date.split('|')[2].trim() }</span>
						</div>
					</div>
					{this.props.meeting.type !== 'past' && (
						<>
							<hr className="meeting-divider"/>
							<div className="meeting-invite-container">
								<MeetingInvite meeting={this.props.meeting} />
							</div>
							<hr className="meeting-divider"/>
						</>
					)}
					
					{this.props.meeting.type === 'past' && <hr className="meeting-divider no-border"/>}

					<div className="meeting-materials-container">
						{ this.getDocuments( 'attachments' ) }
						{ this.getDocuments( 'minutes' ) }
						{this.props.meeting.type !== 'past' && this.props.rollCallState.includes( meeting.ID ) && this.getRollCallAttendance() }
					</div>
				</div>
			</div>
		);

	}

}

function mapStateToProps( { meetings, myCommittees, calendarMessage, generatingDocument, loadingState, rollCallState, committees, meetingDocuments, rollCallAttendance } ) {
	return {
		meetings,
		myCommittees,
		calendarMessage,
		generatingDocument,
		loadingState,
		rollCallState,
		committees,
		meetingDocuments,
		rollCallAttendance
	};
}

export default connect( mapStateToProps, {
	getCalendarInvite,
	removeCalendarMessage,
	downloadDocument,
	setLoadingState
} )( MeetingTile );